// extracted by mini-css-extract-plugin
export var slider = "Switch-module--slider--FAbyr";
export var toggleInput = "Switch-module--toggleInput---G4m+";
export var toggleSwitch = "Switch-module--toggleSwitch--DXWxQ";